/* eslint-disable react-hooks/exhaustive-deps */
// libraries
import Image from 'next/image';
import Link from 'next/link';
import { FaFacebook, FaInstagram, FaPhoneAlt, FaTwitter, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { IconEmail, IconFacebook, IconInstagram, IconLinkedin, IconTelephone, IconThreads, IconTiktok, IconTwitter, IconWhatsapp, IconYoutube } from '../../../assets';
import { isColorLight, MaskPhone } from '../../../utils/FunctionsGlobals';
import { resolveSite2524WhatsAppUrl } from '../../../utils/site2524WhatsApp';
import { appendCodsiteQuery } from '../../../utils/url';

// utils
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styles from './Topo.module.css';

const Topo: React.FC<{
    site: any;
    setActiveDrawer: any
}> = ({ site, setActiveDrawer }) => {
    const cor_texto = isColorLight(site?.cor1) && site?.navbar_transparente ? site?.cor11 : site?.cor13;
    const logoHeight = Number(site?.id) === 2539 ? 250 : site?.tamanho_logo;
    const router = useRouter();
    const { codsite } = router.query;
    const codsiteValue = Array.isArray(codsite) ? codsite[0] : codsite;
    // O codsite só é resolvido no cliente (appendCodsiteQuery usa window.location.host).
    // Anexar apenas após a montagem mantém o href idêntico no SSR e na 1ª render do
    // cliente, evitando o hydration mismatch "Prop href did not match" em host de teste/preview.
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    const withCodsite = (path: string) =>
        isMounted ? appendCodsiteQuery(path, codsiteValue) : path;
    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: IconInstagram,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.threads || '',
            id: 6,
            icon: IconThreads,
            rede: 'Threads'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: IconFacebook,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: IconTwitter,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: IconTiktok,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: IconYoutube,
            rede: 'Youtube'
        },
        {
            href: site?.Dados?.Linkedin || '',
            id: 7,
            icon: IconLinkedin,
            rede: 'Linkedin'
        },
    ];

    const openDrawer = () => {
        setActiveDrawer(true);
    };
    const trackLeadLazy = () => {
        void import('../../whatsAppButton/WhatsAppButton')
            .then(({ trackLead }) => {
                trackLead(site, null);
            })
            .catch(() => undefined);
    };

    const renderText = () => {
        if (site?.id) {
            if(site?.texto_botao_whats){
                return `${site?.texto_botao_whats}`;
            }
            return `Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`;
        }
        return 'Olá, estou visitando o site, gostaria de um atendimento personalizado. Pode me ajudar?';
    };

    const buildContactUrl = (phone: string, isWhatsApp?: boolean) => {
        const cleanPhone = phone?.replace(/\D/g, '');
        const fallbackUrl = isWhatsApp
            ? site?.id == "1937"
                ? `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${renderText()}`
                : `https://api.whatsapp.com/send?phone=55${cleanPhone}&text=${renderText()}`
            : site?.id == "1937"
                ? `tel:${cleanPhone}`
                : `tel:+55${cleanPhone}`;

        return isWhatsApp ? resolveSite2524WhatsAppUrl(site, fallbackUrl) : fallbackUrl;
    };

    return (
        <div className={styles.header_main}>
            {site?.id == '2102' && (
                <Image
                    className={styles.header_background2}
                    alt={`Imobiliária ${site?.Dados?.empresa}`}
                    src="https://fotos.sobressai.com.br/Banner/2102/11030.jpg"
                    fill
                    sizes="100vw"
                    priority
                    style={{objectFit: 'cover'}}
                />
            )}
            {site?.navbar_transparente && site?.id != '2102' ?
                <div className={styles.header_background}
                    style={logoHeight > 1 ?
                        site?.id == "2350" ?
                            {background: '#ffffff', opacity: 1} :
                        site?.id == "2098" || site?.id == 2272 ?
                            {opacity: 1, background: site?.cor1,height: logoHeight} :
                        site?.id == "2127" ?
                            {opacity: 1,background: site?.cor1,height: logoHeight} :
                        site?.id == "2184" ?
                            {opacity: 1,background: site?.cor1,height: logoHeight} :
                        { background: site?.cor1, height: logoHeight} :
                    {background: site?.cor1}}>
                </div> :
                <div className={styles.header_background}
                    style={logoHeight > 1 ? { height: logoHeight }:{}}>
                </div>}
            <div
                className={`${styles.header_main} ${site?.id == 2080 ? styles.header_main_logo_center_2080 : ''}`}
                style={
                    logoHeight > 1
                        ? Number(site?.id) === 2539
                            ? { height: logoHeight, marginTop: 20 }
                            : { height: logoHeight }
                        : Number(site?.id) === 2539
                            ? { marginTop: 20 }
                            : {}
                }
            >
                <div className={styles.flex_ant}/>
                <div className={site?.id == "2473" ?
                    styles.flex_photo_center_2473
                    :
                    site?.id == 2080 ?
                        styles.flex_photo_center_2080
                    :
                    site?.id == "2127" || site?.id == "2042" || site?.id == "2109" || site?.id == "2130" || site?.id == "2483" ?
                    site?.Dados?.tel1 && site?.id != "2042" ?
                        styles.flex_photo_center1
                    :
                        styles.flex_photo_center
                    :
                    site?.id == "2014" ?
                        styles.flex_photo_left
                    :
                        styles.flex_photo}

                    style={site?.id == '1825' ? {justifyContent: 'left'} : site?.id == 2126 ? {justifyContent: 'center'} : {justifyContent: 'center'}}>
                    {site?.url_logo && site?.id != '2102' ? (
                        <Link prefetch={false} href={withCodsite("/")}>
                            <Image
                                src={site?.id == 2259 ? "https://fotos.sobressai.com.br/Banner/2259/11399.jpg" : site?.id == "1706" ? "https://fotos.sobressai.com.br/Banner/1706/11072.jpg" : site?.id == "2127" ? "https://fotos.sobressai.com.br/Banner/2127/11097.png" : `${site?.url_logo}?v=${site?.contador_marca || 0}`}
                                alt={`Imobiliária ${site?.Dados?.empresa}`}
                                title={`Imobiliária ${site?.Dados?.empresa}`}
                                className={site?.id == 1630 ? styles.logo_welcome_1630 : site?.id == 2331 ? styles.logo_welcome_2331 : site?.id == 2539 ? styles.logo_welcome_2539 : site?.id == 2259 ? styles.logo_welcome3 : site?.id == 2304 || site?.id == 2316 ? styles.logo_welcome4 : site?.id == 2178 ? styles.logo_welcome2 : styles.logo_welcome}
                                style={site?.id == 1630 ? {maxHeight: "160px !important"} : site?.id == 2216 || site?.id == 2483 ? {maxHeight: "200px !important",marginTop: "20px !important"} : site?.id == 1825 ? {objectPosition: "left",marginLeft: "0px !important"} : site?.id == 1059 ? {minHeight: "171px !important", maxHeight: "171px !important"} : site?.id == 2080 ? {objectPosition: "center", marginLeft: 0} : {}}
                                height={logoHeight > 1 ? logoHeight : 100}
                                width={site?.id == "2112" ? 230 : site?.id == "2109" || site?.id == 2433 ? 440 : 340}
                            />
                        </Link>
                    ) : (
                        <div className={styles.logo_empty} />
                    )}
                    {site?.id == 2265 && (
                        <Image
                            src="https://fotos.sobressai.com.br/Banner/2265/11395.jpg"
                            alt="Mascote"
                            style={{maxHeight: 150,height: logoHeight > 1 ? logoHeight : 100}}
                            width={150}
                            height={150}
                        />
                    )}
                </div>
                {site?.id == "2106" &&
                    <div className={styles.texto_centro}>
                        <h3>ACREDITAMOS NO SEU SONHO!!!</h3>
                        <h3>Imóveis - Seguros - Consórcios</h3>
                    </div>
                }

                <div className={styles.flex} style={site?.id == "2473" ? {flexShrink: 0} : {}}>
                    {site?.id == "2133" &&
                        <div className={styles.texto_centro}>
                            <a
                                className={styles.btn}
                                href="https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link" target="_blank" rel="noreferrer">
                                Anuncie
                            </a>
                        </div>
                    }
                    {site?.Dados?.tel1 && site?.id != "2042" && site?.id != "2400" && site?.id != "1946" && site?.id != "2057" && site?.id != "2102" && site?.id != "2523" ?
                        <a
                            className={styles.flex1}
                            rel="noopener noreferrer"
                            href={buildContactUrl(site?.Dados?.tel1, site?.Dados?.tel1_whats)}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLeadLazy(); // Registra o evento Lead

                                // Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    buildContactUrl(site?.Dados?.tel1, site?.Dados?.tel1_whats),
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                             {site?.id == 2259 || site?.id == 1630 || site?.id == 2347 || site?.id == 2331 || site?.id == 2470 || site?.id == 2471 ?
                                <FaWhatsapp fill='black' style={{display: "flex",alignItems: "center",fontSize: 28,fill: 'white'}}/>
                            :
                            site?.id == 2239 && !site?.Dados?.tel1_whats ?
                            <FaPhoneAlt style={{fontSize: 20, color: "white"}}></FaPhoneAlt>
                            :
                            <Image
                                height={site?.id == 2348 ? 37 : 24}
                                width={site?.id == 2348 ? 37 : 24}
                                alt="Icon Contato 1"
                                title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 1' : 'Icone Telefone 1'}
                                src={site?.Dados?.tel1_whats ? IconWhatsapp : IconTelephone}
                            />}
                            {site?.id != 2331 &&
                                <div
                                    className={styles.columnContato}
                                    style={{color: cor_texto}}
                                    >
                                    {site?.id === 1958
                                        ? "+55 (71) 99333-6547"
                                        : site?.id === 1937
                                        ? site?.Dados?.tel1
                                        : MaskPhone(site?.Dados?.tel1)}

                                    {site?.id !== 2243 && (
                                        <div
                                        className={styles.type_number}
                                        style={site?.id == 2348 ? { color: "white",fontSize: 15 } : {color: cor_texto}}
                                        >
                                        {site?.Dados?.tel1_nome ? site?.Dados?.tel1_nome : "WhatsApp"}
                                        </div>
                                    )}
                                </div>
                            }
                        </a>
                    :null}
                   {site?.id == 2219 && (
                    <a
                        className={styles.flex1}
                        rel="noopener noreferrer"
                        href={`https://api.whatsapp.com/send?phone=5551999711308&text=${renderText()}`}
                        onClick={async (e) => {
                        e.preventDefault(); // Evita redirecionamento automático
                        trackLeadLazy(); // Registra o evento Lead

                        setTimeout(() => {
                            window.open(
                            `https://api.whatsapp.com/send?phone=5551999711308&text=${renderText()}`,
                            "_blank"
                            );
                        }, 300);
                        }}
                    >
                        <Image
                        height={24}
                        width={24}
                        alt="Icone WhatsApp 2219"
                        title="Icone WhatsApp 2219"
                        src={IconWhatsapp}
                        />
                        <div
                        className={styles.columnContato}
                        style={{color: cor_texto}}
                        >
                        {MaskPhone("51999711308")}
                        <div
                            className={styles.type_number}
                            style={{color: cor_texto}}
                        >
                            Luci Argenta
                        </div>
                        </div>
                    </a>
                    )}
                    {site?.Dados?.tel2 && site?.id != "2042" && site?.id != "2400" && site?.id != "1946" && site?.id != "2057" && site?.id != "2102" && site?.id != "2288" ?
                        <a
                            className={styles.flex1}
                            rel="noopener noreferrer"
                            href={buildContactUrl(site?.Dados?.tel2, site?.Dados?.tel2_whats)}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLeadLazy(); // Registra o evento Lead

                                // Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    buildContactUrl(site?.Dados?.tel2, site?.Dados?.tel2_whats),
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                            {site?.id == 2259 || site?.id == 1630 ?
                                <FaWhatsapp fill='black' style={{display: "flex",alignItems: "center",fontSize: 28,fill: 'white'}}/>
                            :
                            site?.id == 2239 && !site?.Dados?.tel2_whats ?
                            <FaPhoneAlt style={{fontSize: 20, color: "white"}}></FaPhoneAlt>
                            :
                            <Image
                                height={24}
                                width={24}
                                alt="Icon Contato 2"
                                title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 2' : 'Icone Telefone 2'}
                                src={site?.Dados?.tel2_whats ? IconWhatsapp : IconTelephone}
                            />}
                            <div className={styles.columnContato } style={{color: cor_texto}}>
                                {site?.id == "1937" ? site?.Dados?.tel2 : MaskPhone(
                                        site?.Dados?.tel2
                                )}
                                <div className={styles.type_number} style={{color: cor_texto}}>
                                    {site?.Dados?.tel2_nome ? site?.Dados?.tel2_nome : "Comercial"}
                                </div>
                            </div>
                        </a>
                    :null}
                    {(Number(site?.id) === 2537 || Number(site?.id) === 2551) && site?.Dados?.tel3 ?
                        <a
                            className={styles.flex1}
                            rel="noopener noreferrer"
                            href={buildContactUrl(site?.Dados?.tel3, site?.Dados?.tel3_whats)}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automÃ¡tico

                                trackLeadLazy(); // Registra o evento Lead

                                // Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    buildContactUrl(site?.Dados?.tel3, site?.Dados?.tel3_whats),
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                            <Image
                                height={24}
                                width={24}
                                alt="Icon Contato 3"
                                title={site?.Dados?.tel3_whats ? 'Icone WhatsApp 3' : 'Icone Telefone 3'}
                                src={site?.Dados?.tel3_whats ? IconWhatsapp : IconTelephone}
                            />
                            <div className={styles.columnContato } style={{color: cor_texto}}>
                                {site?.id == "1937" ? site?.Dados?.tel3 : MaskPhone(
                                        site?.Dados?.tel3
                                )}
                                <div className={styles.type_number} style={{color: cor_texto}}>
                                    {site?.Dados?.tel3_nome ? site?.Dados?.tel3_nome : "Comercial"}
                                </div>
                            </div>
                        </a>
                    :null}
                    {site?.id == 1825 ?
                        <a
                            className={styles.flex1}
                            rel="noopener noreferrer"
                            href={`https://api.whatsapp.com/send?phone=+5547991389248}&text=${renderText()}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLeadLazy(); // Registra o evento Lead

                                // Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    `https://api.whatsapp.com/send?phone=+5547991389248}&text=${renderText()}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                            {site?.id == 1630 && site?.Dados?.tel2_whats ?
                                <FaWhatsapp style={{fontSize: 28, color: "white"}}/>
                                :
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 2"
                                    title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 2' : 'Icone Telefone 2'}
                                    src={site?.Dados?.tel2_whats ? IconWhatsapp : IconTelephone}
                                />
                            }
                            <div className={styles.columnContato } style={{color: cor_texto}}>
                                (47) 99138-9248
                                <div className={styles.type_number} style={{color: cor_texto}}>
                                    Locação
                                </div>
                            </div>
                        </a>
                    :null}
                    {site?.id == 2473 ?
                        <a
                            className={styles.flex1}
                            rel="noopener noreferrer"
                            href={`https://api.whatsapp.com/send?phone=+5511941271805&text=${renderText()}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLeadLazy(); // Registra o evento Lead

                                // Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    `https://api.whatsapp.com/send?phone=+5511941271805}&text=${renderText()}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                            <Image
                                height={24}
                                width={24}
                                alt="Icon Contato 2"
                                title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 2' : 'Icone Telefone 2'}
                                src={site?.Dados?.tel2_whats ? IconWhatsapp : IconTelephone}
                            />
                            <div className={styles.columnContato } style={{color: cor_texto}}>
                                 (11) 94127-1805
                                <div className={styles.type_number} style={{color: cor_texto}}>
                                    Carlos Munhoz
                                </div>
                            </div>
                        </a>
                    :null}
                    {site?.id == 2033 &&
                        <a className={styles.blog} href="https://appmoradaimoveisrs.com.br/morada" data-no-quicklink
                            data-no-instant
                            data-no-prefetch
                            title="Área do Cliente"
                            target='_blank'
                            rel="noopener noreferrer">
                            Área do Cliente
                        </a>
                    }
                    {site?.redes_topo &&
                        <>
                        {site?.id == "1836" &&
                            <a className={styles.blog} href="https://antigo.estilogramadoimoveis.com.br/blog" data-no-quicklink
                                data-no-instant
                                data-no-prefetch
                                rel="nofollow">
                                Blog
                            </a>
                        }
                        <div className={styles.redes_sociais}>
                            <div className={styles.container1} style={{display: 'flex'}}>
                                {site?.id == "2321" &&
                                    <a
                                        rel="noopener noreferrer"
                                        href="mailto:contato@fcaimoveis.com.br"
                                        target='_blank'
                                        title={`Navegar para o email da imobiliária`}
                                        className={styles.adjust_img1}
                                    >
                                        <Image
                                            alt={`Imagem Email`}
                                            src={IconEmail}
                                            height={30}
                                            width={30}
                                        />
                                    </a>
                                }
                                {site?.id == "2485" &&
                                    <a
                                        rel="noopener noreferrer"
                                        href="https://www.instagram.com/conect.consorcios?igsh=MTVzbXkxbmtxMnUzYw=="
                                        target='_blank'
                                        title={`Navegar para Instagram da imobiliária Conect Consorcios`}
                                        className={styles.adjust_img1}
                                    >
                                        <Image
                                            alt={`Imagem rede social Instagram`}
                                            src={IconInstagram}
                                            height={30}
                                            width={30}
                                        />
                                    </a>
                                }
                                {allSocials?.map((v) => {
                                    if (v) {
                                        if (v.href) {
                                            return (
                                                <a
                                                    aria-label={v.href}
                                                    rel="noopener noreferrer"
                                                    key={v.id}
                                                    href={v.href}
                                                    title={`Navegar para o ${v.rede} da imobiliária`}
                                                    onClick={async (e) => {
                                                        e.preventDefault(); // Evita o redirecionamento automático

                                                        trackLeadLazy(); // Registra o evento Lead

                                                        // Garante que o evento seja enviado antes de abrir o WhatsApp
                                                        setTimeout(() => {
                                                        window.open(
                                                            v.href,
                                                            "_blank"
                                                        );
                                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                    }}
                                                    className={styles.adjust_img1}
                                                    style={site?.id != 2493 && v.id == 7 ? {display: "none"} : site?.id == 2245 && v.id == 3 ? {color: "#ffffff",display: "flex",alignItems: "center",gap: 5,justifyItems: "center",fontWeight: 600}  : {}}
                                                >
                                                    {site?.id == 2523 && v?.id == 3 ? (
                                                        <Image
                                                            alt="Imagem rede social Instagram"
                                                            src="https://imob3.sobressai.com.br/img/icone/instagram.svg"
                                                            height={30}
                                                            width={30}
                                                        />
                                                    ) : site?.id == 2523 && v?.id == 1 ? (
                                                        <Image
                                                            alt="Imagem rede social Facebook"
                                                            src="https://imob3.sobressai.com.br/img/icone/facebook.svg"
                                                            height={30}
                                                            width={30}
                                                        />
                                                    ) : site?.id == 2523 && v?.id == 2 ? (
                                                        <Image
                                                            alt="Imagem rede social Youtube"
                                                            src="https://imob3.sobressai.com.br/img/icone/youtube.svg"
                                                            height={30}
                                                            width={30}
                                                        />
                                                    ) : site?.id == 2115 || site?.id == 1630 || site?.id == 2346 || site?.id == 2471 ? (
                                                        v.rede == "Facebook" ? (
                                                            <FaFacebook style={{ fontSize: 28, color: "white" }} />
                                                        ) : v.rede == "Instagram" ? (
                                                            <FaInstagram style={{ fontSize: 28, color: "white" }} />
                                                        ) : v.rede == "Youtube" ? (
                                                            <FaYoutube style={{ fontSize: 28, color: "white" }} />
                                                        ) : (
                                                            <Image
                                                                alt={`Imagem rede social ${v.rede}`}
                                                                src={v.icon}
                                                                height={30}
                                                                width={30}
                                                            />
                                                        )
                                                    ) : site?.id == 2259 ? (
                                                        v?.id == 3 ? (
                                                            <FaInstagram fill="black" style={{ display: "flex", alignItems: "center", fontSize: 28, fill: "white" }} />
                                                        ) : v?.id == 1 ? (
                                                            <FaFacebook fill="black" style={{ display: "flex", alignItems: "center", fontSize: 28, fill: "white" }} />
                                                        ) : v?.id == 2 ? (
                                                            <FaYoutube fill="black" style={{ display: "flex", alignItems: "center", fontSize: 28, fill: "white" }} />
                                                        ) : v?.id == 4 ? (
                                                            <FaTwitter fill="black" style={{ display: "flex", alignItems: "center", fontSize: 28, fill: "white" }} />
                                                        ) : (
                                                            <Image
                                                                alt={`Imagem rede social ${v.rede}`}
                                                                src={v.icon}
                                                                height={37}
                                                                width={37}
                                                            />
                                                        )
                                                    ) : (
                                                        <Image
                                                            alt={`Imagem rede social ${v.rede}`}
                                                            src={v.icon}
                                                            height={30}
                                                            width={30}
                                                        />
                                                    )}
                                                    {
                                                        site?.id == 2245 && v.id == 3 && "@w.m_imoveis"
                                                    }
                                                </a>
                                            );
                                        }
                                        return null;
                                    }
                                    return null;
                                })}
                            </div>
                        </div>
                        </>
                    }
                    <div className={styles.options_header_welcome}>
                        <div
                            className={styles.icon_drawer}
                            onClick={openDrawer}
                        >
                            <svg
                                viewBox="0 0 24 24"
                                height="1.75rem"
                                width="1.75rem"
                                aria-hidden="true"
                                focusable="false"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                style={{fill: site?.id == 2523 ? '#d8b349' : cor_texto}}
                            >
                                <path fill="none" d="M0 0h24v24H0V0z"></path>
                                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Topo;
